import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { Select } from '@bambi/component-library/src/components/inputs/Select/Select';

import { FormFieldController } from './FormField/FormFieldController';
import { serviceTypeOptions } from 'src/features/add-trip/ServiceDetails/serviceTypeOptions';

export function ServiceTypeField({ fieldName }: { fieldName: string }) {
  return (
    <FormFieldController name={fieldName}>
      {({ field }) => {
        return (
          <DefaultFormFieldLayout label="Service Type" inputId={fieldName}>
            <Select
              value={field.value}
              options={serviceTypeOptions}
              testIdSuffix={fieldName}
              onChange={(selected) => {
                field.onChange(selected?.value);
              }}
            />
          </DefaultFormFieldLayout>
        );
      }}
    </FormFieldController>
  );
}
